var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.862,18.509H18.924a.862.862,0,0,1,0,1.723H6.862a.862.862,0,0,1,0-1.723ZM6,14.2l8.616-8.616L17.2,8.17,8.585,16.786H6Zm9.478-9.478L17.2,3l2.585,2.585L18.061,7.309Z","transform":"translate(-6 -3)","fillRule":"evenodd","fill":"currentColor"}));
}

Edit.defaultProps = {"width":"13.786","height":"17.232","viewBox":"0 0 13.786 17.232"};

module.exports = Edit;

Edit.default = Edit;
